import i18n from '@app/i18n'

const _tryToGetErrorMessage = (error: unknown): string => {
  try {
    if (
      typeof error === 'object' &&
      error?.response &&
      error?.response?.data &&
      error?.response?.data?.title &&
      typeof error?.response?.data?.title === 'string'
    ) {
      const title = error?.response?.data?.title
      const message = error?.response?.data?.message
        ? error?.response?.data?.message
        : ''
      return `${title}\n${message}`
    }

    if (
      typeof error === 'object' &&
      error?.response &&
      error?.response?.data &&
      error?.response?.data?.error &&
      typeof error?.response?.data?.error === 'string'
    ) {
      return error?.response?.data?.error
    }

    if (
      typeof error === 'object' &&
      error?.response &&
      error?.response?.data &&
      error?.response?.data?.message &&
      typeof error?.response?.data?.message === 'string'
    ) {
      return error?.response?.data?.message
    }

    if (
      typeof error === 'object' &&
      error?.response &&
      error?.response?.data &&
      typeof error?.response?.data === 'string'
    ) {
      return error?.response?.data
    }

    if (
      typeof error === 'object' &&
      error?.message &&
      typeof error?.message === 'string'
    ) {
      return error.message
    }

    if (typeof error === 'string') {
      return error
    }

    return i18n.t('errors.notification.unexpectedError')
  } catch (catchedError) {
    console.error('catchedError', catchedError)
    return i18n.t('errors.notification.unexpectedError')
  }
}

export const tryToGetErrorMessage = (error: unknown): string => {
  const message = _tryToGetErrorMessage(error)

  if (
    typeof message === 'string' &&
    message?.toLowerCase?.() === 'internal server error'
  ) {
    return i18n.t('errors.internalServerError')
  } else {
    return message
  }
}
